module.exports = __webpack_public_path__ + "static/media/thean-hou.c48b48b6.jpeg";